module.exports = __webpack_public_path__ + "4e475794a2fe1253d2d9365eebf7f95b.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/hand/ice-powers-s.png
// module id = 2052
// module chunks = 0